import Vue from "vue";
import api from "../ApiBase";

export default {
    async getApiItems(echtId) {
        try {
            const response = await api.get("GetApiItems?echtId=" + echtId);
            return response;
        } catch (error) {
            Vue.$toast.error("Failed to fetch API items");
            throw error;
        }
    }
}